import BpkModal from '@skyscanner/backpack-web/bpk-component-modal';

import ScrollableDateRangeSelector from '../../ScrollableDateRangeSelector';
import DateRange from '../DateRange';

import type { I18nService } from '@shared/types/i18n';
import type { Maybe } from '@shared/types/utils';
import type { ModalClose } from '@shared/ui/types';

import { HASH_CHECK_IN_CHECK_OUT } from '@shared/constants/hash-routes';
import HashRoute from '@shared/ui/common/HashRoute';
import RouteLink from '@shared/ui/common/RouteLink';
import { withI18n } from '@shared/ui/contexts/i18n';
import { getApplicationElement } from '@shared/utils-frontend/ApplicationElements';

type Props = {
  i18n: I18nService;
  startDate: Maybe<Date>;
  endDate: Maybe<Date>;
  onApply: Function;
  dateRangeClassName?: string;
};

const onOpenModal = () => {
  window.name = 'DVSearchModalIsOpen';
};

const FullScreenScrollableDateRangeSelector = ({
  dateRangeClassName,
  endDate,
  i18n,
  onApply,
  startDate,
}: Props) => (
  <>
    <RouteLink
      shouldGoBack={false}
      href={HASH_CHECK_IN_CHECK_OUT}
      onClick={onOpenModal}
      render={(onClickLink) => (
        <DateRange
          onClickLink={onClickLink}
          checkInDate={startDate}
          checkOutDate={endDate}
          className={dateRangeClassName}
        />
      )}
    />
    <HashRoute
      hash={HASH_CHECK_IN_CHECK_OUT}
      render={({
        onClose,
      }: {
        // eslint-disable-next-line react/no-unused-prop-types
        onClose: ModalClose;
      }) => (
        <BpkModal
          isOpen
          onClose={onClose}
          getApplicationElement={getApplicationElement}
          padded={false}
          title={i18n.translate('Explore_label_Dates')}
          id="explore label dates"
        >
          <ScrollableDateRangeSelector
            startDate={startDate}
            endDate={endDate}
            onApply={onApply}
            onClose={onClose}
          />
        </BpkModal>
      )}
    />
  </>
);

export default withI18n(FullScreenScrollableDateRangeSelector);
